import { gql } from 'graphql-request';

export const getCompanyConfig = gql`
  query getConfigData {
    wawiAssist {
      getConfigData {
        id
        countryId
        companyLanguageId
        decimalPlacesCount
        isShippingFunctionActivated
        isBakery2bActivated
        isDefaultEmailTextForInvoice
        customEmailTextForInvoice
        isDefaultEmailTextForOrder
        isDefaultEmailTextForOffer
        customEmailTextForOffer
        customEmailTextForOrder
        isDefaultEmailTextForDebtor
        customEmailTextForDebtor
        orderPositionsSortingKindId
        kiloAmountRepresentationId
        defaultFontOfNoteInOrder
        isDoughInLitersInProductionReports
        isAllowSameEANForMultipleArticles
        isShowShippingPointsInArticle
        nextDeliveryDate
        companyNameInReports
        fibuClient
        fibuVatCodeNormal
        fibuVatCodeReduced
        fibuVatCodeWithoutVAT
        canForbidIncomingOrdersCAdirect
        canWorkWithVersionsInProduction
        globalTaxSystemId
        isUseProcurementLogicInProductionReports
        isDatevCommitment
        isAutoCustomerNo
        autoCustomerNoPrefix
        autoCustomerNoCounter
        actualInvoiceNo
        actualOrderNo
        roundingArticlePricesMethodId
        isUsePriceCategoryAhead
        isGotoNextDeliveryDay
        roundingTotalPricesMethodId
        orderTypesFilterInProductionReportsCheckedState {
          id
          checked
        }
        standardBankId
        besrFormatId
        operationCostCenter
        currentUser {
          name
          company
          role
          avatarUrl
          userLanguageId
        }
        isPrintingAvailable
        isCADBAvailable
        isRADBAvailable
        companySalutation
        companyName
        companyAddition
        companyStreet
        companyZipCode
        companyCity
        companyPhone
        companyFax
        companyEmail
        companyWebsite
        companyGLN
        companyVatNo
        companyTimeZone
        bankName
        bankBIN
        bankAccountNo
        bankIBAN
        creditorIdNumber
        bankBIC
        isDeliveryOnMon
        isDeliveryOnTue
        isDeliveryOnWed
        isDeliveryOnThu
        isDeliveryOnFri
        isDeliveryOnSat
        isDeliveryOnSun
        isShowSplittedAmountInLiters
        isShowRASemiproductsDetails
        useTourSettingForEveryOrder
        oneTimeCustomerDefaultSettingsId
      }
    }
  }
`;

export const saveConfigData = gql`
  mutation saveConfigData($dataToSave: WA_SaveConfigInput!) {
    wawiAssist {
      saveConfigData(dataToSave: $dataToSave) {
        status
      }
    }
  }
`;
